<template>


  <div class="dark">
          <InsideBanner />
		<h1 class="inside_page_name">Awards</h1>
    <PCard :piece = 'loadedPiece' :editable = 'editable' />

  </div>
</template>

<script>
import PCard from '@/components/PCard.vue'
import InsideBanner from "@/components/InsideBanner.vue";

export default {
  name: "Awards",
        components: {
        PCard,
        InsideBanner
      },
  data() {
    return {
      editable: false,
      loadedPiece: 
       { series: 'Artistic Awards',
        skill: 'Santa Cruz County Fair',
        imageUrl: "/tyler_awards.jpg",
        title: "Sculpture Awards",
        description: '<ul><li class="react"><strong>Special Award Fine Arts Youth,</strong> Santa Cruz County Fair - September 2018</li><br><li class="react"><strong>First Place Fine Arts Youth,</strong> Santa Cruz County Fair - September 2018</li><br><li class="react"><strong>Excellence in Technique,</strong> Santa Cruz County Fair - September 2018</li><br><li class="react"><strong>First Place Fine Arts Youth,</strong> Santa Cruz County Fair - September 2017</li><br</ul>',
        vidId: '',
        category: 'sculpture'
       }
    }
  }

}
</script>

